export default function WelcomeComponent() {
  const cardsMap = [
    {
      name: "API Authentication",
      link: "auth-using-api",
    },
    {
      name: "Test Run API",
      link: "test-run",
    },
    {
      name: "Project Management",
      link: "project-management",
    },
    {
      name: "Error Handling",
      link: "error-handling",
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center bg-white pb-16 !mt-0">
      <div className="max-w-3xl w-full text-center">
        <h1 className="text-[3.4em] mb-4 font-raleway-700 font-bold">
          Welcome to <span className="text-[#27AE60]">Flicktest API</span>
        </h1>
        <p className="text-[#282828] mb-8 font-poppins font-normal ">
          You can use the Flicktest API to easily manage projects, create test
          suites, and generate test cases. It simplifies your testing workflow
          with secure authentication and smooth error handling for efficient
          integration.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 font-poppins">
          {cardsMap.map((item, index) => (
            <a href={`/apis/${item.link}`}>
              <button className="flex items-center justify-between group border-2 border-gray-200 rounded-lg p-4 shadow-sm hover:border-[#89AAFF] transition-colors font-medium text-[#1F1F1F] w-full">
                <span className="font-semibold">{item.name}</span>
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="group-hover:stroke-[#316BFF] stroke-[#898187]"
                    d="M5.88889 8.94444L8.33333 6.5M8.33333 6.5L5.88889 4.05556M8.33333 6.5H1M1.92617 9.55556C2.91282 11.0296 4.59308 12 6.5 12C9.53759 12 12 9.53759 12 6.5C12 3.46244 9.53759 1 6.5 1C4.59308 1 2.91282 1.97046 1.92617 3.44444"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
